import { render, staticRenderFns } from "./PJCustomerAddress.vue?vue&type=template&id=fd72ec4c"
import script from "./PJCustomerAddress.vue?vue&type=script&lang=js"
export * from "./PJCustomerAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports